<template>
  <section class="bg-white rounded-lg ring-1 ring-gray-600/10 overflow-clip">
    <header class="flex pl-6 pr-4 justify-between pt-4 items-center bg-white">
      <div>
        <slot name="header"></slot>
      </div>
      <div class="flex items-center gap-x-2">
        <button type="button" class="swiper-button-prev" aria-label="Previous slide">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27 44">
            <path d="M0,22L22,0l2.1,2.1L4.2,22l19.9,19.9L22,44L0,22L0,22L0,22z" />
          </svg>
        </button>

        <button type="button" class="swiper-button-next" aria-label="Next slide">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27 44">
            <path d="M27,22L27,22L5,44l-2.1-2.1L22.8,22L2.9,2.1L5,0L27,22L27,22z" />
          </svg>
        </button>
      </div>
    </header>

    <div class="swiper !py-6" ref="slider">
      <div class="swiper-wrapper items-stretch">
        <slot></slot>
      </div>
    </div>
  </section>
</template>

<script>
import Swiper, { Navigation } from 'swiper';
import 'swiper/css'
import 'swiper/css/navigation';

export default {
  mounted() {
    new Swiper(this.$refs.slider, {
      modules: [Navigation],
      slidesPerView: 1,
      spaceBetween: 32,
      grabCursor: true,
      navigation: {
        nextEl: this.$el.querySelector('.swiper-button-next'),
        prevEl: this.$el.querySelector('.swiper-button-prev'),
      },
      breakpointsBase: 'container',
      breakpoints: {
        600: {
          slidesPerView: 1.25,
          spaceBetween: 24
        },
        700: {
          slidesPerView: 1.5,
        },
        900: {
          slidesPerView: 2.25,
          slidesPerGroup: 2,
        },
        1250: {
          slidesPerView: 2.75
        },
        1500: {
          slidesPerView: 3.5,
          slidesPerGroup: 3
        },
        // Likely doesn't reach the below unless full window width
        1800: {
          slidesPerView: 3.75
        },
        2000: {
          slidesPerView: 4.25
        }
      }
    })
  }
}
</script>

<style lang="postcss" scoped>
.swiper {
  width: 100%;
  height: 100%;
  @apply px-6 pt-3;
}

.swiper-button-next,
.swiper-button-prev {
  position: static;
  width: 36px;
  height: 36px;
  margin: 0;
  color: #000;
  @apply flex items-center justify-center rounded-md bg-white shadow-none transition-shadow duration-200 ease-out ring-1 ring-black/10;

  &:hover {
    @apply shadow-md ring-teal-300;
  }

  svg {
    width: 11px;
    fill: currentColor;
  }

  &::after { display: none; }

  &.swiper-button-disabled {
    @apply opacity-20 ring-0;
  }
}

:deep(.swiper-slide) {
  height: auto;
}
</style>
